import { Conf2AccountJwt, jwt } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class Conf2AccountSignInRequestDTO extends BaseRequestDTO<Conf2AccountSignInRequestDTORaw> {
  private static validation = JsonSchemaValidator.compile(
    Conf2AccountSignInRequestDTO.validationSchema()
  );

  constructor(value: Conf2AccountSignInRequestDTORaw) {
    super(
      JsonSchemaValidator.assert(Conf2AccountSignInRequestDTO.validation, value)
    );
  }

  override toJSON(): object {
    return {
      jwt: this.value.jwt
    };
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["jwt"],
      properties: {
        jwt
      },
      additionalProperties: false
    };
  }
}

interface Conf2AccountSignInRequestDTORaw {
  jwt: Conf2AccountJwt;
}
